import { useGetAccountQuery, useUseToggleStrandedAssetTeamMutation } from '@/services/accounts';
import { Button, toast, useOpenClose } from '@palmetto/palmetto-components';
import React from 'react';
import { useParams } from 'react-router-dom';

import { MoveStrandedAccountModal } from './MoveStrandedAssetAction.modal';

const MoveStrandedAssetAction: React.FC = () => {
  const {
    isOpen: isStrandedActionModalOpen,
    handleOpen: openStrandedActionModal,
    handleClose: closeModal,
  } = useOpenClose();
  const { id } = useParams<{ id: any }>();
  const { data: accountData, isLoading } = useGetAccountQuery(id);
  const [toggle, { isLoading: dataIsUpdating }] = useUseToggleStrandedAssetTeamMutation();

  if (isLoading) {
    return null;
  }

  const buttonLabel = accountData?.strandedFulfillment?.ownedByStrandedAssetTeam
    ? 'Remove from Untrancheable Asset Team'
    : 'Move to Untrancheable Asset Team';

  const isAssigned = accountData?.strandedFulfillment?.ownedByStrandedAssetTeam;

  const updateFunction = async () => {
    try {
      const successMessage = isAssigned
        ? 'Account removed from Untrancheable Asset Team successfully'
        : 'Account moved to Untrancheable Asset Team successfully';
      await toggle({
        toggle: {
          ownedByStrandedAssetTeam: !isAssigned,
        },
        id: accountData.id,
      }).unwrap();
      toast.success(successMessage);
    } catch (e) {
      const errorMessage = isAssigned
        ? 'Failed to remove account from Untrancheable Asset Team'
        : 'Failed to move account to Untrancheable Asset Team';
      toast.error(errorMessage);
      console.error({ e });
    }
    closeModal();
  };

  return (
    <>
      <MoveStrandedAccountModal
        isModalOpen={isStrandedActionModalOpen}
        handleCloseModal={closeModal}
        isAssigned={accountData?.strandedFulfillment?.ownedByStrandedAssetTeam}
        dataIsUpdating={dataIsUpdating}
        updateFunction={updateFunction}
      />
      <Button
        variant="tertiary"
        tone="danger"
        size="xs"
        onClick={openStrandedActionModal}
        disabled={dataIsUpdating || isLoading}
      >
        {buttonLabel}
      </Button>
    </>
  );
};

export default MoveStrandedAssetAction;
